import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { BulkUpdateGLCodeRequest } from 'src/types/department';
import axiosInstance from 'src/utils/axios';

interface UseBulkUpdateGLCodeMutationOptions {
  companyId: string;
  onSuccess?: (data: AxiosResponse<any>) => void;
  onError?: (error: any) => void;
}

const useBulkUpdateGLCodeMutation = ({
  companyId,
  onSuccess,
  onError,
}: UseBulkUpdateGLCodeMutationOptions) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: BulkUpdateGLCodeRequest) => {
      const res = await axiosInstance.post(api.bulkUpdateGLCode(companyId), params);
      return res;
    },
    onSuccess: (data) => {
      // Invalidate department list queries to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.department.departmentList(companyId.toString())],
      });
      // Invalidate clients query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.company.clients(companyId.toString())],
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useBulkUpdateGLCodeMutation;
